/* eslint-disable react/jsx-no-target-blank */
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import {
  MerchantStatus,
  MerchantType,
} from '../../../../../pages/siteIntelligence/client/mappings';
import MultiSelection from '../../components/MultiSelection';
import SearchInputGroup from '../../components/SearchInputGroup';
import { useFilter } from '../../FilterContext';

interface SelectType {
  readonly value: string | string[];
  readonly label: string;
}

export function CdrnClientsFilter() {
  const params = useParams();
  const intl = useIntl();
  const { globalFilter, setGlobalFilter } = useFilter();

  const type: SelectType[] = [
    {
      value: MerchantType.SUB_MERCHANT,
      label: intl.formatMessage({ id: 'CLIENTS.TYPE_OPTIONS.SUB_MERCHANT' }),
    },
    {
      value: MerchantType.DIRECT_MERCHANT,
      label: intl.formatMessage({ id: 'CLIENTS.TYPE_OPTIONS.DIRECT_MERCHANT' }),
    },
  ];

  const status: SelectType[] = [
    {
      value: MerchantStatus.PENDING,
      label: intl.formatMessage({ id: 'CLIENTS.STATUS_OPTIONS.PENDING' }),
    },
    {
      value: MerchantStatus.PROCESSING,
      label: intl.formatMessage({ id: 'CLIENTS.STATUS_OPTIONS.PROCESSING' }),
    },
    {
      value: MerchantStatus.ACTIVE,
      label: intl.formatMessage({ id: 'CLIENTS.STATUS_OPTIONS.ACTIVE' }),
    },
    {
      value: MerchantStatus.DELETED,
      label: intl.formatMessage({ id: 'CLIENTS.STATUS_OPTIONS.DELETED' }),
    },
    {
      value: MerchantStatus.REJECTED,
      label: intl.formatMessage({ id: 'CLIENTS.STATUS_OPTIONS.REJECTED' }),
    },
  ];

  return (
    <>
      <div className={clsx(params.id ? 'blur' : '')}>
        <div className='d-flex'>
          {/* Type */}
          <MultiSelection
            title={intl.formatMessage({ id: 'CLIENTS.TYPE' })}
            globalFilterValue={globalFilter?.['cdrnClientList']?.type?.values}
            options={type}
            onChange={(e) => {
              setGlobalFilter({
                ...globalFilter,
                cdrnClientList: {
                  ...globalFilter.cdrnClientList,
                  type: { type: 'in', values: e },
                },
              });
            }}
          />

          {/* Status */}
          <MultiSelection
            title={intl.formatMessage({ id: 'CLIENTS.STATUS' })}
            globalFilterValue={globalFilter?.['cdrnClientList']?.status?.values}
            options={status}
            onChange={(e) => {
              setGlobalFilter({
                ...globalFilter,
                cdrnClientList: {
                  ...globalFilter.cdrnClientList,
                  status: { type: 'in', values: e },
                },
              });
            }}
          />

          {/* Search */}
          <SearchInputGroup
            inputs={[
              // key = filter key
              { key: 'name', title: intl.formatMessage({ id: 'CLIENTS.CLIENT_NAME' }) },
              { key: 'merchant_id', title: intl.formatMessage({ id: 'CLIENTS.CLIENT_ID' }) },
            ]}
            section='cdrnClientList' // globalFilter section key
            globalFilterValue={globalFilter}
            onSubmit={(searchValues) =>
              setGlobalFilter({
                ...globalFilter,
                cdrnClientList: {
                  ...globalFilter.cdrnClientList,
                  ...searchValues,
                },
              })
            }
            onClear={(searchValues) =>
              setGlobalFilter({
                ...globalFilter,
                cdrnClientList: {
                  ...globalFilter.cdrnClientList,
                  ...searchValues,
                },
              })
            }
          />
        </div>
      </div>
    </>
  );
}
